import { BaseModel } from "../../core/classes/BaseModel";
import { ApiAsync } from "../../core/classes/ApiAsync";

export class User extends BaseModel {
  constructor(params) {
    super(params);
  }

  $fields() {
    return [
      "id",
      "username",
      "email",
      "password",
      "active",
      "locked",
      "avatar",
      "description",
      "roles",
    ];
  }
}
